import {Fragment, useState, useEffect} from 'react'
import Chat from './Chat'
import Sidebar from './SidebarLeft'
import UserProfileSidebar from './UserProfileSidebar'
import classnames from 'classnames'
import {useDispatch, useSelector} from 'react-redux'
import {getChatUsersProfile} from '../chatAdmin/store/actions'
import '@styles/base/pages/app-chat.scss'
import '@styles/base/pages/app-chat-list.scss'
import {PropTypes} from "prop-types"

const AppChat = (props) => {
    const dispatch = useDispatch()
    const store = useSelector(state => state.chat)
    const chatAdminStore = useSelector(state => state.chatAdmin)
    const [user, setUser] = useState({})
    const [sidebar, setSidebar] = useState(false)
    const [userSidebarRight, setUserSidebarRight] = useState(false)
    const [userSidebarLeft, setUserSidebarLeft] = useState(false)

    const handleSidebar = () => {
        setSidebar(!sidebar)
        dispatch(getSingleUserChats())
    }
    const handleUserSidebarLeft = () => setUserSidebarLeft(false)
    const handleUserSidebarRight = () => setUserSidebarRight(false)
    const handleOverlayClick = () => {
        setSidebar(false)
        setUserSidebarRight(false)
        setUserSidebarLeft(false)
    }

    const handleUser = obj => setUser(obj)

    useEffect(() => {
        dispatch(getChatUsersProfile())
    }, [dispatch])

    return (
        <Fragment>
            <Sidebar
                store={chatAdminStore}
                generalUserId={props.mainUser}
                sidebar={sidebar}
                handleSidebar={handleSidebar}
                userSidebarLeft={userSidebarLeft}
                handleUserSidebarLeft={handleUserSidebarLeft}
            />
            <div className='content-right'>
                <div className='content-wrapper'>
                    <div className='content-body'>
                        <div className={classnames('body-content-overlay', {
                            show: userSidebarRight === true || sidebar === true || userSidebarLeft === true
                        })}>
                            <button onClick={handleOverlayClick} className='btn btn-link p-0'></button>
                        </div>
                        <Chat
                            store={store}
                            handleUser={handleUser}
                            handleSidebar={handleSidebar}
                            userSidebarLeft={userSidebarLeft}
                            handleUserSidebarRight={handleUserSidebarRight}
                            generalUserId={props.mainUser}
                        />
                        <UserProfileSidebar
                            user={user}
                            userSidebarRight={userSidebarRight}
                            handleUserSidebarRight={handleUserSidebarRight}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

AppChat.propTypes = {
    mainUser: PropTypes.string.isRequired
}

export default AppChat
